import { Controller } from "@hotwired/stimulus"

// Toggle de campos condicionales: un checkbox muestra/oculta contenido.
//
// Uso en ERB:
//   <div data-controller="manage--toggle-field">
//     <label data-action="click->manage--toggle-field#toggle">
//       <input type="checkbox" data-manage--toggle-field-target="checkbox">
//     </label>
//     <div data-manage--toggle-field-target="content" class="hidden">
//       ...campos condicionales...
//     </div>
//   </div>

export default class extends Controller {
  static targets = ["checkbox", "content"]

  connect() {
    this._applyToggle()
  }

  // Llamado desde data-action="click->..." en el label que envuelve el checkbox.
  // El browser actualiza el estado del checkbox como acción por defecto del click en el label,
  // DESPUÉS de que el evento se procesa. requestAnimationFrame difiere la lectura al siguiente
  // frame, cuando el estado ya cambió.
  toggle() {
    requestAnimationFrame(() => this._applyToggle())
  }

  // Variante sincronica. Usar cuando el listener este bindeado al evento `change`
  // del propio checkbox (no al click de un label envolvente). Para `change`, el
  // browser ya cambio el estado del input cuando el handler corre, asi que no
  // hace falta requestAnimationFrame. Sincronia importa cuando el mismo evento
  // tambien dispara un form-auto-submit que toma FormData inmediato — el toggle
  // debe haber corrido antes para que los inputs queden enabled.
  applyNow() {
    this._applyToggle()
  }

  _applyToggle() {
    if (!this.hasContentTarget) return
    if (!this.hasCheckboxTarget) return

    const checked = this.checkboxTarget.checked
    this.contentTargets.forEach((el) => {
      el.classList.toggle("hidden", !checked)
    })

    // Disable/enable inputs dentro del content para que no se envíen al server
    this.contentTargets.forEach((el) => {
      el.querySelectorAll("input, select, textarea").forEach((input) => {
        input.disabled = !checked
      })
    })
  }
}
